<template lang="pug">
  b-card.border-0.customerCard.tempInput(
    bg-variant="light"
  )
    label.w-100.mb-0(
      :for="`checkbox-group-${index}`"
    )
      .row.mb-5
        .col-2.d-flex.align-items-center.justify-content-center(
          v-show="selectMode"
        )
          b-form-checkbox(
            :id="`checkbox-group-${index}`",
            name="selectTemps",
            :checked="isChecked"
            v-show="selectMode",
            @input="selectTempHandler(originalData.id, originalData.type)",
            :class="{ 'hidden-check': isChecked }"
          )
            label.check-label(
              v-if="isChecked"
            ) {{ order + 1 }}
        .position-relative(
          :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
        )
          span.white-space-pre-line {{ originalData.push_format.text }}
      .position-relative
        label.mb-0.d-flex.flex-row-reverse.position-absolute.toolsButton(
          style="right: 10px;bottom: -10px;",
          :for="`dropTools_${index}`",
          @click="toolsHandler(index)",
          v-if="editMode"
        )
          input.toolsInput.d-none(
            type="checkbox",
            :id="`dropTools_${index}`",
            :name="`dropTools_${index}`",
            :checked="toolsOpen.indexOf(index) !== -1"
          )
          b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.iconToolsBtn(
            variant="primary"
          )
            i.fas.fa-tools.iconTools
          b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconEditBtn(
            variant="primary",
            @click="editHandler(originalData.id)",
            v-if="editBtnShow"
          )
            i.fas.fa-pencil-alt.iconEdit
          b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconDeleteBtn(
            variant="primary",
            @click="deleteHandler(originalData.id)",
            v-if="deleteBtnShow"
          )
            i.far.fa-trash-alt.iconDelete
          b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconCopyBtn(
            variant="primary",
            @click="copyHandler(originalData.id)",
            v-if="copyBtnShow"
          )
            i.far.fa-copy.iconCopy
        small.font-size-sm 建立者：{{ originalData.creator }}

</template>

<script>
const _ = require('lodash');

export default {
  name: 'text-input',
  props: {
    index: [String, Object, Number],
    // 父層資訊
    originalData: {
      type: Object,
      required: true
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false
    },
    selectTemps: {
      type: Array
    },
    editBtnShow: {
      type: Boolean,
      default: true
    },
    deleteBtnShow: {
      type: Boolean,
      default: true
    },
    copyBtnShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      toolsOpen: []
    };
  },
  methods: {
    selectTempHandler(id, template) {
      const vm = this;
      vm.$emit('selectTempHandler', {
        id,
        template
      });
    },
    // 打開工具
    toolsHandler(index) {
      const vm = this;
      if (vm.toolsOpen.indexOf(index) === -1) {
        vm.toolsOpen.push(index);
      } else {
        vm.toolsOpen.splice(vm.toolsOpen.indexOf(index), 1);
      }
    },
    editHandler(id) {
      const vm = this;
      vm.$emit('editTempHandler', {
        id
      });
    },
    deleteHandler(id) {
      const vm = this;
      vm.$emit('deleteTempHandler', {
        id
      });
    },
    copyHandler(id) {
      const vm = this;
      vm.$emit('copyTempHandler', {
        id
      });
    }
  },
  computed: {
    isChecked() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id && val.type === vm.originalData.type);
      if (key) {
        return true;
      }
        return false;
    },
    order() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id);
      return parseInt(key);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
